// extracted by mini-css-extract-plugin
export default {"vehicles":"styles_vehicles__hC+o8","vehicles__content":"styles_vehicles__content__HTlzf","preloader":"styles_preloader__3wPGO","vehicles__list":"styles_vehicles__list__eDgy4"};